/**
 * Calculates the mean value from an array of numbers, filtering out null values.
 *
 * @param {Array<number|null>} values - Array of numeric values that may include nulls
 * @returns {number} The mean of non-null values, or 0 if no valid values exist
 */
export const mean = values => {
  if (!Array.isArray(values) || values.length === 0) {
    return 0
  }

  const validValues = values.filter(val => val != null)

  return validValues.length > 0
    ? validValues.reduce((sum, val) => sum + val, 0) / validValues.length
    : 0
}
